import { render, staticRenderFns } from "./PhraseDisposalList.vue?vue&type=template&id=5909654c&"
import script from "./PhraseDisposalList.vue?vue&type=script&lang=js&"
export * from "./PhraseDisposalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports